const Brand = {
    BrandList: () => 'store/brands',
    AddBrand: () => 'store/brand',
    deleteBrand: (id:string) => `store/brand/${id}`,
    brandSearch:()=> 'store/brand/search',
    onlineStatus:(id:string)=>`store/brand/${id}/ecommerce-status/toggle`,
    editBrandDiscount:(id:string)=> `store/brand/${id}/ecom-discount`
}
export default Brand